export default {
  // Search selectors
  transactionDirection: "Transaction Direction",
  currency: "Currency",
  pleaseSelect: "Please Select",
  transactionAmount: "Transaction Amount",
  transactionCount: "Transaction Count",
  minAmount: "Min Amount",
  maxAmount: "Max Amount",
  maxAmountWarning: "Max amount must be ≥ min amount",

  // Buttons
  reset: "Reset",
  query: "Query",

  // Data statistics
  totalData: "Total {count} records",

  // Loading
  loading: "Loading...",

  // Table columns
  direction: "Direction",
  count: "Count",
  currencyName: "Currency",
  totalAmount: "Total Amount",

  // Transaction direction
  buy: "Buy",
  sell: "Sell",
  unknown: "Unknown",

  // Empty state
  noOtcData: "No OTC transaction data parsed from current investigation file",

  // Download
  downloadDetails: "Download Details",
};
